import { render, staticRenderFns } from "./combinationImg.vue?vue&type=template&id=956d9bc6&scoped=true&"
import script from "./combinationImg.vue?vue&type=script&lang=js&"
export * from "./combinationImg.vue?vue&type=script&lang=js&"
import style0 from "./combinationImg.vue?vue&type=style&index=0&id=956d9bc6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956d9bc6",
  null
  
)

export default component.exports